export const EVENT_STOCK_ADD = "EVENT_STOCK_ADD"
export const EVENT_STOCK_ADD_SUCCESS = "EVENT_STOCK_ADD_SUCCESS"
export const EVENT_STOCK_ADD_FAILURE = "EVENT_STOCK_ADD_FAILURE"
export const FETCHING_STOCKS= "FETCHING_STOCKS"
export const FETCHED_STOCKS = "FETCHED_STOCKS"
export const FETCH_STOCKS_ERROR = "FETCH_STOCKS_ERROR"

export const ADDING_STOCK_ITEM_UNIT = "ADDING_STOCK_ITEM_UNIT"
export const ADDING_STOCK_ITEM_UNIT_SUCCESS = "ADDING_STOCK_ITEM_UNIT_SUCCESS"
export const ADDING_STOCK_ITEM_UNIT_FAILURE = "ADDING_STOCK_ITEM_UNIT_FAILURE"
export const RESET_ADDING_STOCK_ITEM_UNIT = "RESET_ADDING_STOCK_ITEM_UNIT"
export const ADD_DEFAULT_STOCK_UNITS = "ADD_DEFAULT_STOCK_UNITS"

export const ADDING_STOCK  = "ADDING_STOCK"
export const ADDING_STOCK_SUCCESS = "ADDING_STOCK_SUCCESS"
export const ADDING_STOCK_FAILURE = "ADDING_STOCK_FAILURE"
export const RESET_ADDING_STOCK = "RESET_ADDING_STOCK"

export const DELETING_STOCK = "DELETING_STOCK"
export const DELETING_STOCK_SUCCESS = "DELETING_STOCK_SUCCESS"
export const DELETING_STOCK_FAILURE = "DELETING_STOCK_FAILURE"
export const RESET_DELETING_STOCK= "RESET_DELETING_STOCK"

export const UPDATING_STOCK = "UPDATING_STOCK"
export const UPDATING_STOCK_SUCCESS = "UPDATING_STOCK_SUCCESS"
export const UPDATING_STOCK_FAILURE = "UPDATING_STOCK_FAILURE"
export const RESET_UPDATING_STOCK = "RESET_UPDATING_STOCK"

// stock item update actions
export function resetUpdatingStock() {
  return {
    type: RESET_UPDATING_STOCK,
    data: {}
  }
}

export function updatingStock() {
  return {
    type: UPDATING_STOCK,
    data: {}
  }
}
export function updatingStockSuccess(stock_item) {
  return {
    type: UPDATING_STOCK_SUCCESS,
    data: stock_item,
  }
}
export function updatingStockFailure(err) {
  return {
    type: UPDATING_STOCK_FAILURE,
    data: err
  }
}

// stock item delete actions
export function resetDeletingStock() {
  return {
    type: RESET_DELETING_STOCK,
    data: {}
  }
}

export function deletingStock() {
  return {
    type: DELETING_STOCK,
    data: {}
  }
}
export function deletingStockSuccess(stock_item) {
  return {
    type: DELETING_STOCK_SUCCESS,
    data: stock_item,
  }
}
export function deletingStockFailure(err) {
  return {
    type: DELETING_STOCK_FAILURE,
    data: err
  }
}

// stock item actions new
export function resetAddingStock() {
  return {
    type: RESET_ADDING_STOCK,
    data: {}
  }
}

export function addingStock() {
  return {
    type: ADDING_STOCK,
    data: {}
  }
}

export function addingStockSuccess(stock_item) {
  return {
    type: ADDING_STOCK_SUCCESS,
    data: stock_item
  }
}
export function addingStockFailure(err) {
  return {
    type: ADDING_STOCK_FAILURE,
    data: err
  }
}


// stock item unit actions

export function addDefaultStockUnits(stock_units) {
  return {
    type: ADD_DEFAULT_STOCK_UNITS,
    data: stock_units
  }
}

export function resetAddingStockUnit() {
  return {
    type: RESET_ADDING_STOCK_ITEM_UNIT,
    data: {}
  }
}
export function addingStockUnit() {
  return {
    type: ADDING_STOCK_ITEM_UNIT,
    data: {}
  }
}
export function addingStockUnitSuccess(stockunit) {
  return {
    type: ADDING_STOCK_ITEM_UNIT_SUCCESS,
    data:stockunit
  }
}
export function addingStockUnitFailure(err) {
  return {
    type: ADDING_STOCK_ITEM_UNIT_FAILURE,
    data: err
  }
}


// Stock List actions
export function fetchingStocks() {
  return {
    type: FETCHING_STOCKS,
    data: null
  }
}
export function fetchedStocks(stocks){
  return {
    type: FETCHED_STOCKS,
    data: stocks
  }
}

export function fetchStocksError(err) {
  return {
    type: FETCH_STOCKS_ERROR,
    data: err
  }
}

// Stock item actions
// export function addStockItem() {
//   return {
//       type: EVENT_STOCK_ADD,
//       data: {}
//   }
// }
// export function addStockItemSuccess(stockitem) {
//   return {
//     type: EVENT_STOCK_ADD_SUCCESS,
//     data: stockitem
//   }
// }
// export function addStockItemFailure(error) {
//   return {
//     type: EVENT_STOCK_ADD_FAILURE,
//     data: error
//   }
// }



// WEBPACK FOOTER //
// ./src/redux/actions/stockactions.js